import { defineComponent as _defineComponent } from 'vue'
import Merchants from './components/merchants.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'auth-info-site',
  setup(__props) {


return { __sfc: true,Merchants }
}

})